import React, { useEffect, useState } from "react";
import liracrypt from "../../components/Liracrypt/liracrypt";
import { Form, Row, Col, notification, message, Spin } from "antd";
import SessionError from "../../components/ApiErrorComp/SessionError";
import { LoadingOutlined } from "@ant-design/icons";
import InputIdentify from "../InputCreater/InputCreater";
import FooterButtons from "../../components/STORM/FooterButtons";
import HModal from "../HModal";
import dayjs from "dayjs";
import ZenMultiLines from "../../components/PhantomZen/ZenMultiLines";
import RoutePage from "../../components/RoutePage";
import { useLocation, useHistory } from 'react-router-dom';
import queryString from "query-string";
import Scanter from "../../components/STORM/Scanter";
import { useSelector } from "react-redux";
import ApiErrorComp from "../../components/ApiErrorComp/ApiErrorComp";
import { createRoute } from "../../utils/CustomFunc";
import ZenFormInput from "../InputCreater/ZenFormInput";
import ZenModal from "../../components/ZenModal";

function StAddNew({
  dropdownExtraData,
  setSmodalTitle,
  onFormSubmit,
  popUpModal,
  formName,
  urlMethod,
  colSpan,
  setPageHeader,
  setSmodalConfig,
  urlEndpoint,
  urlData,
  dictName,
  pageName,
  extraData,
  ModalHeader,
  onCallFinish,
  stopResetForm,
  setConfig,
  initForm,
  setSelectedLid
}) {
  const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;
  const urlCode = useSelector(state => state.urlCode);
  const { search } = useLocation();
  const history = useHistory();
  const searchParams = queryString.parse(search);
  const [loader, setLoader] = useState(false);
  const LocalDict = [];
  const dtArray = ["datePicker", "rangePicker", "dateTimePicker"];
  const [footerButtons, setFooterButtons] = useState({});
  const [modalElement, setModalElement] = React.useState(null);
  const [url, setUrl] = React.useState(null);
  const [method, setMethod] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [loginError, setLoginError] = React.useState(false);
  // const [submitBtnText, setSubmitBtnTxt] = React.useState("Add New");
  const [render, setRender] = React.useState(true);

  const [modalHeader, setModalHeader] = React.useState(ModalHeader);
  const [selectedButton, setSelectedButton] = useState();
  const [isHModalVisible, setIsHModalVisible] = useState(false);
  const [action, setAction] = useState({});
  const [staddNewConfig, setStAddNewConfig] = useState();
  const [_form] = Form.useForm();
  const [zenModal, setZenModal] = useState();
  const [modal, setModal] = useState({
    // type: props.config.zenModal.typ,
    type: "",
    data: undefined,
    show: false,
    loading: false,
  });
  const toggleModal = ({ show = false, data = undefined, type = "", loading = false }) => {
    setModal({ show, data, type, loading });
  }

  const openSmodal = (btnData) => {
    setZenModal(btnData.smodalProp);
    return toggleModal({
      show: true,
      data: {
        urlData: { ...searchParams, ...btnData?.smodalProp?.params }
      },
      type: 'smodal',
      loading: false
    });
  }


  const form = initForm ? initForm : _form





  const openPopupModal = (button) => {
    setIsHModalVisible(true);
    setAction({ edit: button.popUpModalProp });
  }

  const onResponse = ({ data, button, onlyPostSubmitAction, barCode }) => {
    if (data) {
      if (!data?.isSuccess) {
        return message.error(
          data?.message
            ? data?.message
            : "Oops! Something went wrong"
        );
      }
      message.success(
        data?.message
          ? data?.message
          : "Submitted Successfully"
      );
    };
    let btnData = button || selectedButton;

    if (btnData.buttonProp?.smodal && !onlyPostSubmitAction) {
      return openSmodal(btnData);
    };
    if (btnData.buttonProp?.popUpModal && !onlyPostSubmitAction) {
      return openPopupModal(btnData);
    };

    if (!btnData?.buttonProp?.postSubmitAction) {
      if (onCallFinish) {
        if (!stopResetForm) {
          form.resetFields();
        }
        onCallFinish({ data });
      }
      return;
    };
    if (btnData?.postSubmitActionProp?.action === "prefillValue") {
      console.log(btnData?.postSubmitActionProp?.prefillValueDataIndex, barCode)
      return form.setFieldsValue({ [btnData?.postSubmitActionProp?.prefillValueDataIndex]: barCode })
    }
    if (btnData?.postSubmitActionProp?.action === "refreshStable") {
      if (onCallFinish) {
        onCallFinish({ data });
      }
      document.getElementById("phantomPrimeSbmt").click();
      return;
    }
    if (btnData?.postSubmitActionProp?.action === "refreshLineDashboard") {
      let formValues = form.getFieldsValue();
      setSelectedLid(formValues?._id);
      if (onCallFinish) {
        form.resetFields();
        onCallFinish({});
      }
      return;
    }
    if (btnData?.postSubmitActionProp?.action === "clearForm") {
      form.resetFields();
      if (onCallFinish) {
        onCallFinish({ data });
      }

    }
    if (btnData?.postSubmitActionProp?.action === "blankPage") {
      setModalElement(null);
    };
    if (btnData?.postSubmitActionProp?.action === "reloadStorm") {
      setModalElement(null);
      fetchAPI();
    }
    if (btnData?.postSubmitActionProp?.action === "newTab") {
      if (btnData?.postSubmitActionProp?.routeTyp === 'dynamic') {
        let route = createRoute({
          route: data?.route,
          props: btnData?.postSubmitActionProp?.props,
          multiProps: btnData?.postSubmitActionProp?.multiProps,
          record: data,
          urlCode,
          params: { ...searchParams, ...btnData?.postSubmitActionProp?.params },
        });
        window.open(route, '_blank');
      } else {
        let route = createRoute({
          route: btnData.postSubmitActionProp.route,
          props: btnData?.postSubmitActionProp?.props,
          multiProps: btnData?.postSubmitActionProp?.multiProps,
          record: data,
          urlCode,
          params: { ...searchParams, ...btnData?.postSubmitActionProp?.params },
        });
        window.open(route, '_blank');
      }
    };
    if (btnData?.postSubmitActionProp?.action === "transformPage") {
      if (btnData?.postSubmitActionProp?.routeTyp === 'dynamic') {
        let route = createRoute({
          route: data?.route,
          props: btnData?.postSubmitActionProp?.props,
          multiProps: btnData?.postSubmitActionProp?.multiProps,
          record: data,
          urlCode,
          params: { ...searchParams, ...btnData?.postSubmitActionProp?.params },
        });
        history.push(route);
      } else {
        let route = createRoute({
          route: btnData?.postSubmitActionProp?.route,
          props: btnData?.postSubmitActionProp?.props,
          multiProps: btnData?.postSubmitActionProp?.multiProps,
          record: data,
          urlCode,
          params: { ...searchParams, ...btnData?.postSubmitActionProp?.params },
        });
        history.push(route);
      }
    };

    if (btnData?.postSubmitActionProp?.action === 'reloadPage') {
      window.location.reload();
    };
    if (btnData?.postSubmitActionProp?.action === 'download') {
      let urlData = { ...btnData?.postSubmitActionProp?.params };
      urlData['token'] = localStorage.getItem("token");
      urlData['urlCode'] = urlCode;
      urlData = { ...searchParams, ...urlData };
      let routeParams = new URLSearchParams(urlData);
      let route = `${process.env.REACT_APP_API_ENDPOINT}${btnData?.postSubmitActionProp?.api}?${routeParams}`;
      window.open(route, '_blank');
      return;
    }
  };

  const fetchAPI = () => {
    setLoader(true);
    if (urlMethod === 'POST') {
      liracrypt.post(urlEndpoint, urlData ? { ...searchParams, ...urlData } : {
        dictName,
        ...searchParams
      }).then(res => {
        if (setSmodalTitle) {
          setSmodalTitle(res.data?.config?.pageTitle || res.data?.config?.modalHeader);
        };
        if (setPageHeader) {
          setPageHeader(res.data?.config?.pageTitle || pageName)
        }
        setLoader(false);
        setModalElement(res.data.config.modalElements);
        setStAddNewConfig(res.data.config);
        if (setConfig) {
          setConfig(res.data.config);
        }
        setFooterButtons(res.data.config.footerButtons);
        setRender(false);
      });
    } else {
      liracrypt.get(urlEndpoint, urlData ? { ...searchParams, ...urlData } : {
        dictName,
        ...searchParams
      }).then(res => {
        if (setSmodalConfig) {
          setSmodalConfig(res.data?.config);
        }
        if (setSmodalTitle) {
          setSmodalTitle(res.data?.config?.pageTitle || res.data?.config?.modalHeader);
        };
        if (setPageHeader) {
          setPageHeader(res.data?.config?.pageTitle || pageName)
        }
        setLoader(false);
        setModalElement(res.data?.config.modalElements);
        setStAddNewConfig(res.data.data);
        if (setConfig) {
          setConfig(res.data.config);
        }
        setFooterButtons(res.data?.config.footerButtons);
        setRender(false);
      }).catch(err => {
        ApiErrorComp();
        console.log(err);
      });
    }
  };

  useEffect(() => {
    if (urlEndpoint) {
      fetchAPI();
    } else {
      if (popUpModal) {
        if (setSmodalConfig) {
          setSmodalConfig(popUpModal);
        }
        if (setSmodalTitle) {
          setSmodalTitle(popUpModal?.pageTitle || popUpModal?.modalHeader);
        };
        if (setPageHeader) {
          setPageHeader(popUpModal?.pageTitle || pageName)
        }
        setLoader(false);
        setModalElement(popUpModal.modalElements);
        setStAddNewConfig(popUpModal.data);
        if (setConfig) {
          setConfig(popUpModal.data);
        }
        setFooterButtons(popUpModal.footerButtons);
        setRender(false);
      } else {
        setModalElement(null)
      }
    }
  }, [urlEndpoint, search, JSON.stringify(urlData)]);

  const onScanterFinish = ({ button, barCode }) => {

    let postData = { ...button?.submitFormDataProp.params };
    postData.barCode = barCode;
    //  postData.seldocs = selectedRowData;
    // setBarCode(barCode);
    if (button?.submitFormDataProp?.method === 'POST') {
      liracrypt.post(button?.submitFormDataProp.url, postData).then(response => {
        if (response.data.isSuccess) {
          notification.success({ message: response.data.message });
          onResponse({ button, response, barCode })
        } else {
          notification.error({ message: response.data.message })
        }
      })
        .catch(err => {
          notification.error({
            message: 'Something went wrong'
          })
        })
    };
    if (button?.submitFormDataProp?.method === 'PATCH') {
      liracrypt.patch(button?.submitFormDataProp.url, postData).then(response => {
        if (response.data.isSuccess) {
          notification.success({ message: response.data.message });
          onResponse({ button, response, barCode })
        } else {
          notification.error({ message: response.data.message })
        }
      })
        .catch(err => {
          notification.error({
            message: 'Something went wrong'
          })
        })
    };
  }

  const EModal = (
    <HModal
      onResponse={onResponse}
      isModalVisible={isHModalVisible}
      setIsModalVisible={setIsHModalVisible}
      modalMethod={"edit"}
      action={action}
      modalData={null}
      preventSubmitBtnClick={true}
    />
  )

  const onFinish = (value) => {
    let data = { ...searchParams, ...extraData, ...value };
    // if (extraData) {
    //   data = { ...searchParams, ...data, ...extraData };
    // }
    Object.keys(data).forEach((key) => {
      if (data[key]) {
        if (Array.isArray(data[key]) && LocalDict[key]) {
          data[
            LocalDict["data_index_from"] ? LocalDict["data_index_from"] : "from"
          ] = dayjs(data[key][0]).format(LocalDict[key]).toString();
          data[LocalDict["data_index_to"] ? LocalDict["data_index_to"] : "to"] =
            dayjs(data[key][1]).format(LocalDict[key]).toString();
          delete data[key];
        } else {
          if (LocalDict[key]) {

            data[key] = dayjs(data[key]).format(LocalDict[key]).toString();
          }
        }
      }
    });
    let formData = new FormData();

    // Object.keys(data).forEach((key) => {
    //   if (data[key] !== undefined && data[key] !== null) {
    //     formData.append(key, data[key]);
    //   }
    // });
    let submitFormDataProp = selectedButton?.submitFormDataProp;
    data = { ...submitFormDataProp?.params, ...data };
    Object.keys(data).forEach(x => {
      let val = data[x];
      if (val !== undefined && val !== null) {
        if (typeof val === 'object') {
          if (!(val instanceof File)) {
            val = JSON.stringify(val);
          }
        }
        formData.append(x, val);
      }
    });

    // Object.keys(data).forEach((element) => {
    //   if (Array.isArray(data[element])) {
    //     let filtered = data[element].filter(function (el) {
    //       return el != null;
    //     });
    //     let temp = filtered.toString();
    //     data[element] = "[" + temp + "]";
    //   }
    // });
    if (onFormSubmit) {
      return onFormSubmit(data)
    }
    if (submitFormDataProp?.method === "POST") {
      setLoading(true);
      if (submitFormDataProp?.dataType === 'formData') {
        liracrypt
          .uploadFile(submitFormDataProp?.api, formData)
          .then(onResponse)
          .catch((err) => {
            console.log(err);
            setLoading(false);
            notification.error({ message: "Oops ! Something went Wrong.." });
            if (err.response !== undefined) {
              if (err.response.status === 401) {
                //   ApiErrorComp(err.response.status);

                setLoginError(true);
              }
            }
          });
      } else {
        liracrypt
          .post(submitFormDataProp?.api, data)
          .then(onResponse)
          .catch((err) => {
            console.log(err);
            setLoading(false);
            notification.error({ message: "Oops ! Something went Wrong.." });
            if (err.response !== undefined) {
              if (err.response.status === 401) {
                //   ApiErrorComp(err.response.status);

                setLoginError(true);
              }
            }
          });
      }
    } else if (submitFormDataProp?.method === "PATCH") {
      setLoading(true);
      if (submitFormDataProp?.dataType === 'formData') {
        liracrypt
          .patch(submitFormDataProp?.api, formData)
          .then(onResponse)
          .catch((err) => {
            setLoading(false);
            console.log(err);
            notification.error({ message: "Oops ! Something went Wrong.." });
            if (err.response !== undefined) {
              if (err.response.status !== 401) {
                //   ApiErrorComp(err.response.status);

                setLoginError(true);
              }
            }
          });
      } else {
        liracrypt
          .patch(submitFormDataProp?.api, data)
          .then(onResponse)
          .catch((err) => {
            setLoading(false);
            console.log(err);
            notification.error({ message: "Oops ! Something went Wrong.." });
            if (err.response !== undefined) {
              if (err.response.status !== 401) {
                //   ApiErrorComp(err.response.status);

                setLoginError(true);
              }
            }
          });

      }

    } else if (submitFormDataProp?.method === "GET") {
      setLoading(true);

      //convert for GET
      Object.keys(data).forEach((element) => {
        if (Array.isArray(data[element])) {
          let filtered = data[element].filter(function (el) {
            return el != null;
          });
          let temp = filtered.toString();
          data[element] = "[" + temp + "]";
        }
      });

      liracrypt
        .get(submitFormDataProp?.api, data)
        .then(onResponse)
        .catch((err) => {
          setLoading(false);
          console.log(err);
          notification.error({ message: "Oops ! Something went Wrong.." });
          if (err.response !== undefined) {
            if (err.response.status !== 401) {
              //   ApiErrorComp(err.response.status);

              setLoginError(true);
            }
          }
        });
    } else if (method === "GET") {
      setLoading(true);

      //convert for GET
      Object.keys(data).forEach((element) => {
        if (Array.isArray(data[element])) {
          let filtered = data[element].filter(function (el) {
            return el != null;
          });
          let temp = filtered.toString();
          data[element] = "[" + temp + "]";
        }
      });

      liracrypt
        .get(url, data)
        .then((res) => {
          setLoading(false);

          notification.success({ message: res.data.message });
          if (onCallFinish) {
            onCallFinish({ data: res.data });
          }

          // hitApi();
          form.resetFields();
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
          notification.error({ message: "Oops ! Something went Wrong.." });
          if (err.response !== undefined) {
            if (err.response.status !== 401) {
              setLoginError(true);
            }
          }
        });
    }
  };

  //   const FormElement = ({ element }) => {
  //     return (

  //     );
  //   };

  return (
    loader ?
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignContent: 'center',
        alignItems: 'center',
        width: '100%'
      }}>
        <Spin indicator={antIcon} />
      </div> :
      <>
        <ZenModal modal={modal} toggleModal={toggleModal} zenModal={zenModal} smodalCallback={() => toggleModal({})} />

        <SessionError loginError={loginError} />
        <div>

          <Row>
            <Col span={24}>
              {
                (staddNewConfig?.config?.zenFuncs?.headerRoute && staddNewConfig?.config?.headerRoute?.route) ?

                  <Col span={24}>
                    <div style={{ width: '500px', display: 'block', margin: 'auto' }}>
                      <RoutePage route={staddNewConfig?.config?.headerRoute?.route} params={{ ...urlData || { dictName }, ...staddNewConfig?.config?.headerRoute?.params }} />
                    </div>
                  </Col> : <></>
              }
            </Col>
            <Col span={24}>
              <ZenMultiLines style={{ backgroundColor: staddNewConfig?.config?.headerMultiline?.['background-color'] || 'transparent' }} classes="zen-multi-header" visible={staddNewConfig?.config?.zenFuncs?.headerMultiline || false} singleLineColumns={staddNewConfig?.config?.headerMultiline?.singleCol || []} multiLineColumns={staddNewConfig?.config?.headerMultiline?.multiCol || []} />
            </Col>
          </Row>
          {modalHeader ? (
            <>
              <div
                style={{
                  backgroundColor: "#007bff",
                  color: "#fff",
                  textAlign: "center",
                  fontWeight: "600",
                  margin: "5px",
                  marginTop: "30px",
                  marginBottom: "20px",
                  borderRadius: "10px",
                  padding: "10px",
                }}
              >
                {modalHeader}
              </div>
            </>
          ) : (
            <></>
          )}
          {modalElement ? (
            <div
              className="AuditSection CreateAudit"
              style={{
                padding: "10px",
                maxHeight: "800px",
                overflowY: "scroll",
                overflowX: "hidden",
              }}
            >
              <div className="ThemeForm">
                <Form
                  labelWrap={true}
                  name={formName || "ReportForm"}
                  form={form}
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}
                  layout="horizontal"
                  colon={false}
                  onFinish={onFinish}
                  size="large"
                >
                  {modalElement.map((data, index) => {
                    if (dtArray.includes(data["typ"])) {

                      LocalDict[data["data_index"]] = data["format"]
                        ? data["format"]
                        : "YYYY-MM-DD hh:mm:ss";
                      LocalDict["data_index_from"] = data["data_index_from"];
                      LocalDict["data_index_to"] = data["data_index_to"];
                    }

                    if (data.visible !== false) {
                      return (
                        <Col span={24} key={index}>
                          <Row justify={"center"}>
                            <ZenFormInput
                              urlData={{ ...urlData }}
                              pageType={"staddnew"}
                              LocalDict={LocalDict}
                              form={form}
                              colSpan={colSpan ? colSpan : 12}
                              name={data["data_index"]}
                              label={data["label"]}
                              defaultValue={data["default"]}
                              typ={data["typ"]}
                              disabled={data["readOnly"]}
                              source={data["source"]}
                              sourceParams={{ ...data["sourceParams"], ...dropdownExtraData }}
                              auxParams={data["auxParams"]}
                              format={data["format"]}
                              errorMessage={data["errorMessage"]}
                              placeHolder={data["placeHolder"]}
                              required={data["required"]}
                              options={data["data"]}
                              from={data["data_index_from"]}
                              to={data["data_index_to"]}
                              url={data["url"]}
                              includeAll={data["includeAll"]}
                              pname={data["p_data_index"]}
                              defaultFrom={data["defaultFrom"]}
                              defaultTo={data["defaultTo"]}
                              multiSelect={data["multiSelect"]}
                              searchable={data["isSearchable"]}
                              data={data}
                              extraData={extraData}
                            />
                          </Row>
                        </Col>
                      );
                    }
                  })}
                  <Row>
                    <Col span={24}>
                      <ZenMultiLines style={{ backgroundColor: staddNewConfig?.config?.footerMultiline?.['background-color'] || 'transparent' }} classes="zen-multi-header" visible={staddNewConfig?.config?.zenFuncs?.footerMultiline || false} singleLineColumns={staddNewConfig?.config?.footerMultiline?.singleCol || []} multiLineColumns={staddNewConfig?.config?.footerMultiline?.multiCol || []} />
                    </Col>
                  </Row>
                  {
                    footerButtons && (
                      <Row gutter={24} justify="center">
                        <Col span={24} style={{ display: 'inline-flex', justifyContent: 'center' }}>
                          {Object.keys(footerButtons).map((btn, idx) => {
                            const button = footerButtons[btn];
                            if (button?.buttonProp?.visible) {
                              return (
                                <React.Fragment key={idx}>
                                  <FooterButtons
                                    postSubmitAction={onResponse}
                                    openPopupModal={openPopupModal}
                                    button={button}
                                    setSelectedButton={setSelectedButton}
                                    openSmodal={openSmodal}
                                    form={form}
                                    label={button?.buttonProp?.label}
                                    type={button?.buttonProp?.type}
                                    disabled={!button?.buttonProp?.enable}
                                    confirmationPopUp={button?.buttonProp?.confirmationPopUp ? button?.confirmationPopUpProp : undefined}
                                    submitFormData={button?.submitFormDataProp}
                                  />
                                </React.Fragment>

                              )
                            }
                          })}
                        </Col>
                      </Row>
                    )
                  }
                </Form>
                {
                  staddNewConfig?.config?.scanter?.buttonProp?.enable && (
                    <Scanter
                      onFinish={onScanterFinish}
                      postSubmitAction={onResponse}
                      openPopupModal={openPopupModal}
                      button={staddNewConfig?.config?.scanter}
                      setSelectedButton={setSelectedButton}
                      form={null}
                      label={staddNewConfig?.config?.scanter?.buttonProp?.label}
                      type={staddNewConfig?.config?.scanter?.buttonProp?.type}
                      disabled={!staddNewConfig?.config?.scanter?.buttonProp?.enable}
                      confirmationPopUp={staddNewConfig?.config?.scanter?.buttonProp?.confirmationPopUp ? staddNewConfig?.config?.scanter?.confirmationPopUpProp : undefined}
                      submitFormData={staddNewConfig?.config?.scanter?.submitFormDataProp}
                    />
                  )
                }
              </div>
              {
                isHModalVisible ?
                  <>{EModal}</> : null
              }
            </div>
          ) : (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  minHeight: "80vh",
                }}
              >
                <LoadingOutlined
                  style={{ fontSize: 80, color: "#007bff" }}
                  spin
                />
              </div>
            </>
          )}
        </div>
      </>
  );
}

export default StAddNew;